import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  BsCheckCircleFill,
  BsExclamationTriangleFill,
  BsInfoCircleFill,
  BsXCircleFill,
} from "react-icons/bs";

export default function Snackbar({
  open,
  message,
  severity = "info",
  onClose,
  duration = 3000,
}) {
  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => onClose?.(), duration);
      return () => clearTimeout(timer);
    }
  }, [open, duration, onClose]);

  // Kolory statusów
  const variants = {
    success: {
      color: "bg-green-500",
      icon: <BsCheckCircleFill className="text-green-500 w-5 h-5" />,
    },
    error: {
      color: "bg-red-500",
      icon: <BsXCircleFill className="text-red-500 w-5 h-5" />,
    },
    warning: {
      color: "bg-yellow-400",
      icon: <BsExclamationTriangleFill className="text-yellow-500 w-5 h-5" />,
    },
    info: {
      color: "bg-blue-500",
      icon: <BsInfoCircleFill className="text-blue-500 w-5 h-5" />,
    },
  };

  const { color, icon } = variants[severity] || variants.info;

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.3 }}
          className="fixed bottom-6 left-1/2 -translate-x-1/2 w-[95%] sm:w-auto max-w-2xl z-50"
        >
          <div className="flex items-center justify-between bg-white text-gray-800 px-5 py-3 rounded-lg shadow-lg border border-gray-200">
            <div className="flex items-center gap-3">
              {icon}
              <span className=" text-sm sm:text-base">{message}</span>
            </div>

          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
